<template>
  <div>
    <b-form class="needs-validation"
            >

      <b-row>
        <b-col xl="5" lg="5" sm="5">
          <p class="mt-3">
            <span class="h3">Subscriber Macaddress</span>
          </p>
        </b-col>
        <b-col xl="7" lg="7" sm="7">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="macAddressStatus"
              v-model="newBroadbandForm.macAddress"
            ></b-form-input>
            <b-form-invalid-feedback :state="macAddressStatus">
              Please enter a valid subscriber macaddress.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="5" lg="5" sm="5">
          <p class="mt-3">
            <span class="h3">Data Plan (TopOff)</span>
          </p>
        </b-col>
        <b-col xl="7" lg="7" sm="7">
          <b-form-group label-for="input-1">
            <b-form-select
              id="period"
              v-model="newBroadbandForm.dataPlan"
              :options="dataPlanOption"
              :state="true"
              value-field="key"
              class="mt-2"
              text-field="label"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
            Close
        </base-button>
        <base-button type="primary" title="Search"  v-on:click="addBroadbandSubmit" :loading="submitLoading">
          Submit
        </base-button>
      </div>
    </b-form>

  </div>
</template>

<script>
  import administratorService from "../../common/api-services/administrator-service";

  export default {
    name: "New-Broadband-Subscriber",
    computed: {
      macAddressStatus() {
        return this.newBroadbandForm.macAddress.length > 0
      },
      dataPlanStatus() {
        return this.newBroadbandForm.dataPlan.length > 0
      }
    },
    data() {
      return {
        newBroadbandForm: {
          macAddress: '',
          dataPlan: ''
        },
        dataPlanOption: [],
        editStatus: false,
        submitLoading: false
      }
    },
    mounted() {
      this.getDataPlanFunc()
    },
    methods: {
      getDataPlanFunc() {
        this.dataPlanOption = []
        administratorService.getDslDataPlans().then(res => {
          if (res && !res.includes('NULL') && !res.includes('FAIL')) {
            res.map(item => {
              let items = {key: item.id, label: item.plan_name};
              this.dataPlanOption.push(items)
            })
          }
        })
      },

      modalClose() {
        this.$bvModal.hide('new-broadband-check');
      },

      addBroadbandSubmit() {
        if (this.macAddressStatus) {
          this.submitLoading = true;
          this.setDslPlanAndBalanceFunc()
        }
      },

      setDslPlanAndBalanceFunc() {
        let plan_name = this.dataPlanOption.find(item => item.key ===  this.newBroadbandForm.dataPlan)['label']
        let macaddress = this.newBroadbandForm.macAddress;
        let amount = String(plan_name).replace('_WK','').split('_')[1].replace('DSL','');
        administratorService.setDslPlanAndBalance(macaddress,amount,plan_name).then(res => {
          this.submitLoading = false;
          let type = ''
          if (res.includes('FAIL')) {
            type = 'error'
          } else {
            type = 'success';
          }
          this.$toast(res, {type: type})
          this.modalClose();
          this.$root.$emit('newBrandSubscriberAdded', true)
        });


      }
    }
  }
</script>

<style scoped>

</style>
